export const mensagemUsuarioBloqueado = {
  USER_BLOCKED: 'Caro parceiro, o seu usuário foi desabilitado pelo administrador.'
}
